import { match } from 'ts-pattern'
import commonPropTypes from '../../../constants/commonPropTypes'
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import PendingTooltip from './pendingTooltip'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const FieldLabel = ({
  className,
  elmId,
  inputName,
  label,
  error = false,
  required = false,
  optional,
  pendingApproval,
  showError,
}) => {
  const requiredOrOptional = match({ required, optional })
    .with({ required: true }, () => <span className={cx('warning')}> *</span>)
    .with({ optional: true }, () => (
      <span>
        <i> (Optional)</i>
      </span>
    ))
    .otherwise(() => null)
  return (
    <span>
      {pendingApproval && <PendingTooltip />}
      <label
        data-elm-id={`${elmId}_label`}
        htmlFor={inputName}
        className={cx('label', className)}
      >
        <span
          className={cx(error && showError ? 'warning' : '')}
          // Surface the full label text natively on hover — useful when the
          // label is ellipsized, harmless otherwise.
          title={typeof label === 'string' ? label : undefined}
        >
          {label}
        </span>
        {requiredOrOptional}
      </label>
    </span>
  )
}

FieldLabel.propTypes = {
  ...commonPropTypes,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  pendingApproval: PropTypes.bool,
}

export default FieldLabel
